import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Container, ContentScrollable, Header } from './styles';
import api from '../../services/api';
import { IPostProjectProps } from '../../dtos/IPostProjectProps';
import IRequestError from '../../dtos/IRequestError';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import PostProjectComponent from '../../components/PostProjectComponent';
import { BlogIcon, CrossIcon } from '../../assets/svg/SVGComponents';
import { useModal } from '../../hooks/modal';
import LoadingState from './LoadingState';

interface CommunityProjectProps {
  post_project_id?: string;
}

const CommunityPost: React.FC<CommunityProjectProps> = ({
  post_project_id,
}) => {
  const { project_id } = useParams<{ project_id?: string }>();
  const { isSessionExpired } = useAuth();
  const { addToast } = useToast();
  const { t } = useTranslation();
  const [post, setPost] = useState<IPostProjectProps>();
  const { closeModal } = useModal();

  // Use prop first (when opened as modal), fallback to URL param
  const resolvedId = post_project_id || project_id;

  const GetPostProject = useCallback(async () => {
    if (!resolvedId) return;

    try {
      const postUser = await api.get(`/posts/${resolvedId}`);
      setPost(postUser.data);
    } catch (err) {
      if (!(await isSessionExpired(err as IRequestError))) {
        addToast({
          type: 'error',
          expression: 'Ops.',
          description: t('toasts.errors.load_data_fail'),
        });
      }
    }
  }, [addToast, isSessionExpired, resolvedId, t]);

  useEffect(() => {
    GetPostProject();
  }, [GetPostProject]);

  if (!resolvedId) {
    return null;
  }

  return (
    <Container>
      <Header>
        <div>
          <BlogIcon width="2rem" stroke="#FF9800" strokeWidth={2} fill="none" />
          <h3>
            <Trans i18nKey="h3.community" />
          </h3>
        </div>

        <CrossIcon
          onClick={closeModal}
          width="1.22rem"
          stroke="#1188e2"
          strokeWidth={1.5}
        />
      </Header>

      {!post && <LoadingState />}
      <ContentScrollable>
        {post && (
          <PostProjectComponent
            {...post}
            hideBorderRadius
            showComments
            /* O modal existe para mostrar este projeto; sem ele, fecha. */
            onDeleted={closeModal}
          />
        )}
      </ContentScrollable>
    </Container>
  );
};

export default CommunityPost;
